import {
  DateTimeRange,
  SinceDateTimeRange,
} from '@modules/common/components/DateRangePicker/types';

export const isSinceDateTimeRange = (
  dateRange: DateTimeRange,
): dateRange is SinceDateTimeRange => {
  return dateRange.type === 'since';
};
